import { useAuth } from '@/src/context/AuthContext';
import { useTheme } from '@/src/context/ThemeContext';
import { getUserLaunchesUseCase } from '@/src/core/dependencies';
import { logger } from '@/src/core/utils';
import { TrainingLaunch } from '@/src/domain/models/TrainingLaunch';
import { useTranslation } from '@/src/i18n';
import { MyLaunchesScreen } from '@/src/presentation/screens/MyLaunchesScreen';
import { Stack } from 'expo-router';
import { useCallback, useEffect, useState } from 'react';

export default function MyLaunchesContainer() {
  const { colors } = useTheme();
  const { user } = useAuth();
  const { t } = useTranslation();

  const [launches, setLaunches] = useState<TrainingLaunch[]>([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const loadLaunches = useCallback(async (isRefresh = false) => {
    if (!user) return;
    if (isRefresh) setRefreshing(true); else setLoading(true);
    try {
      const data = await getUserLaunchesUseCase.execute(user.id);
      setLaunches(data);
    } catch (error) {
      logger.error('MyLaunches', 'Failed to load launches', { error });
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, [user]);

  useEffect(() => {
    loadLaunches();
  }, [loadLaunches]);

  return (
    <>
      <Stack.Screen options={{ title: t('training.myLaunchesTitle') }} />
      <MyLaunchesScreen
        launches={launches}
        loading={loading}
        refreshing={refreshing}
        onRefresh={() => loadLaunches(true)}
        colors={colors}
      />
    </>
  );
}
